<template>
  <header class="header-global">
    <base-nav
      id="navbar"
      class="navbar-main"
      :style="`height:90px; background-size:100% 100%; background-image: url('${base_path}img/theme/blue-sky-white-clouds-line.jpg');`"
      effect="light"
      expand
    >
      <div
        slot="container-after"
        class="header-action-container"
        @click="showApplicationList"
        v-show="show_application_list_entry"
      >
        <div class="header-circle-decoration">
          <b-icon icon="cart3" style="color: white; font-size: 20px;"></b-icon>
        </div>
        <span class="action-text">{{ $t('dharma-application-form.application-list.title') }}</span>
      </div>
      <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
        <img :src="`${base_path}img/brand/wheel_logo.png`" style="height: 7vh;">
		    <img class="word-logo" :src="`${base_path}img/brand/word_logo.png`" style="height: 7vh;">
      </router-link>
      <div class="row" slot="content-header" slot-scope="{closeMenu}">
        <div class="col-10 collapse-brand">
          <a href="/">
			     <img :src="`${base_path}img/brand/wheel_logo.png`">
			     <img :src="`${base_path}img/brand/word_logo.png`">
          </a>
        </div>
        <div class="col-2 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>
      <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
        <base-dropdown tag="li" class="nav-item">
          <a slot="title" href="javascript:void(0);" class="nav-link" data-toggle="dropdown" role="button">
            <span class="nav-link-inner--text">{{ $t('about') }}</span>
            <i class="ni ni-bold-right d-lg-none"></i>
          </a>
          <router-link
            class="dropdown-item dropdown-item-lg"
            :to="{ name: 'introduction' }"
          >{{ $t('introduction.title') }}</router-link>
          <!-- <router-link
            class="dropdown-item dropdown-item-lg"
            :to="{ name: 'founder' }"
          >{{ $t('founder.title') }}</router-link> -->
          <router-link
            class="dropdown-item dropdown-item-lg"
            :to="{ name: 'chairman' }"
          >{{ $t('chairman.title') }}</router-link>
          <router-link
            class="dropdown-item dropdown-item-lg"
            :to="{ name: 'library' }"
            v-if="$i18n.locale === 'tw'"
          >{{ $t('library.title') }}</router-link>
		      <router-link
            class="dropdown-item dropdown-item-lg"
            :to="{ name: 'contact-information' }"
          >{{ $t('contact.title') }}</router-link>
          <router-link
            class="dropdown-item dropdown-item-lg"
            :to="{ name: 'traffic' }"
            v-if="$i18n.locale === 'tw'"
          >{{ $t('traffic.title') }}</router-link>
		      <router-link
            class="dropdown-item dropdown-item-lg"
            :to="{ name: 'support-donation' }"
          >{{ $t('donation.title') }}</router-link>
		      <router-link
            class="dropdown-item dropdown-item-lg"
            :to="{ name: 'recruitments' }"
            v-if="$i18n.locale === 'tw'"
          >{{ $t('recruitment.title') }}</router-link>
        </base-dropdown>
      </ul>
	    <ul class="navbar-nav navbar-nav-hover align-items-lg-center" v-if="$i18n.locale === 'tw'">
        <base-dropdown tag="li" class="nav-item">
          <a slot="title" href="javascript:void(0);" class="nav-link" data-toggle="dropdown" role="button">
            <span class="nav-link-inner--text">{{ $t('announcement') }}</span>
            <i class="ni ni-bold-right d-lg-none"></i>
          </a>
          <router-link
            class="dropdown-item dropdown-item-lg"
            :to="{ name: 'bulletins' }"
          >{{ $t('bulletin.title') }}</router-link>
          <router-link
            class="dropdown-item dropdown-item-lg"
            :to="{ name: 'sidelights' }"
          >{{ $t('sidelight.title') }}</router-link>
          <router-link
            class="dropdown-item dropdown-item-lg"
            :to="{ name: 'weeklies' }"
          >{{ $t('weekly.title') }}</router-link>
		      <router-link
            class="dropdown-item dropdown-item-lg"
            :to="{ name: 'monthlies' }"
          >{{ $t('monthly.title') }}</router-link>
        </base-dropdown>
      </ul>
	    <ul class="navbar-nav navbar-nav-hover align-items-lg-center" v-if="$i18n.locale === 'tw'">
        <base-dropdown tag="li" class="nav-item">
          <a slot="title" href="javascript:void(0);" class="nav-link" data-toggle="dropdown" role="button">
            <span class="nav-link-inner--text">{{ $t('activitie') }}</span>
            <i class="ni ni-bold-right d-lg-none"></i>
          </a>
          <router-link
            class="dropdown-item dropdown-item-lg"
            :to="{ name: 'today-courses' }"
          >{{ $t('course.title') }}</router-link>
          <router-link
            class="dropdown-item dropdown-item-lg"
            :to="{ name: 'latest-session-in-colleges' }"
          >{{ $t('academy.title') }}</router-link>
          <router-link
            class="dropdown-item dropdown-item-lg"
            :to="{ name: 'latest-events' }"
          >{{ $t('hwadzan-garden.title') }}</router-link>
        </base-dropdown>
      </ul>
	    <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
        <base-dropdown tag="li" class="nav-item">
          <a slot="title" href="javascript:void(0);" class="nav-link" data-toggle="dropdown" role="button">
            <span class="nav-link-inner--text">{{ $t('resource') }}</span>
            <i class="ni ni-bold-right d-lg-none"></i>
          </a>
          <router-link
            class="dropdown-item dropdown-item-lg"
            :to="{ name: 'books', params: { group: 'applicable', language: ($i18n.locale === 'tw' ? 'chinese' : 'english') }}"
          >{{ $t('book.title') }}</router-link>
          <router-link
            class="dropdown-item dropdown-item-lg"
            :to="{ name: 'lendable-books' }"
            v-if="$i18n.locale === 'tw'"
          >{{ $t('search.type-selector.option.lendable_book.label') }}</router-link>
          <router-link
            class="dropdown-item dropdown-item-lg"
            :to="{ name: 'recently-added-series' }"
          >{{ $t('series.title') }}</router-link>
          <router-link
            class="dropdown-item dropdown-item-lg"
            :to="{ name: 'pictures', params: { group: 'applicable' } }"
          >{{ $t('picture.title') }}</router-link>
		      <router-link
            class="dropdown-item dropdown-item-lg"
            :to="{ name: 'buddhist-dictionary-tool' }"
            v-if="$i18n.locale === 'tw'"
          >{{ $t('buddhist-dictionary.title') }}</router-link>
          <router-link
            class="dropdown-item dropdown-item-lg"
            :to="{ name: 'buddha-educational-animation' }"
            v-if="$i18n.locale === 'tw'"
          >{{ $t('animation.title') }}</router-link>
        </base-dropdown>
      </ul>
	    <!-- <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
        <base-dropdown tag="li" class="nav-item">
          <a slot="title" href="javascript:void(0);" class="nav-link" data-toggle="dropdown" role="button">
            <span class="nav-link-inner--text">佛學概要</span>
            <i class="ni ni-bold-right d-lg-none"></i>
          </a>
          <router-link to="/examples" class="dropdown-item dropdown-item-lg">佛法基礎</router-link>
		  <router-link to="/examples" class="dropdown-item dropdown-item-lg">佛經選讀</router-link>
		  <router-link to="/examples" class="dropdown-item dropdown-item-lg">各宗祖師傳記</router-link>
		  <router-link to="/examples" class="dropdown-item dropdown-item-lg">佛典故事</router-link>
        </base-dropdown>
      </ul> -->
	    <ul class="navbar-nav navbar-nav-hover align-items-lg-center" v-if="$i18n.locale === 'tw'">
        <base-dropdown tag="li" class="nav-item">
          <a slot="title" href="javascript:void(0);" class="nav-link" data-toggle="dropdown" role="button">
            <span class="nav-link-inner--text">{{ $t('compassion.title') }}</span>
            <i class="ni ni-bold-right d-lg-none"></i>
          </a>
		      <router-link
            class="dropdown-item dropdown-item-lg"
            :to="{ name: 'love-life-articles', params: { type: 'sutra' }}"
          >{{ $t('life-caring-article') }}</router-link>
		      <!-- <router-link
            class="dropdown-item dropdown-item-lg"
            :to="{ name: 'love-life-resources', params: { type: 'cookbook' }}"
          >護生素食譜</router-link> -->
		      <router-link
            class="dropdown-item dropdown-item-lg"
            :to="{ name: 'love-life-resources', params: { type: 'calendar' }}"
          >{{ $t('life-caring-monthly-calendar') }}</router-link>
		      <router-link
            class="dropdown-item dropdown-item-lg"
            :to="{ name: 'love-life-resources', params: { type: 'cartoon' }}"
          >{{ $t('life-caring-picture') }}</router-link>
          <!-- <router-link to="/examples" class="dropdown-item dropdown-item-lg">環保園地</router-link> -->
          <!-- <router-link to="/examples" class="dropdown-item dropdown-item-lg">活動花絮</router-link> -->
        </base-dropdown>
      </ul>
	    <ul class="navbar-nav navbar-nav-hover align-items-lg-center" v-if="$i18n.locale === 'tw'">
        <base-dropdown tag="li" class="nav-item">
          <a slot="title" href="javascript:void(0);" class="nav-link" data-toggle="dropdown" role="button">
            <span class="nav-link-inner--text">{{ $t('partner') }}</span>
            <i class="ni ni-bold-right d-lg-none"></i>
          </a>
          <router-link
            class="dropdown-item dropdown-item-lg"
            :to="{ name: 'amtb' }"
          >{{ $t('amtb.title') }}</router-link>
		      <router-link
            class="dropdown-item dropdown-item-lg"
            :to="{ name: 'other-website' }"
          >{{ $t('other-website.title') }}</router-link>
        </base-dropdown>
      </ul>
      <ul class="navbar-nav navbar-nav-hover align-items-lg-center" v-if="$i18n.locale === 'tw'">
        <li>
          <a
            class="nav-link"
            href="javascript:void(0);"
            @click="setUiLanguage('en')"
          >
            <span class="nav-link-inner--text">English</span>
          </a>
        </li>
      </ul>
      <ul class="navbar-nav navbar-nav-hover align-items-lg-center" v-if="$i18n.locale === 'en'">
        <li>
          <a
            class="nav-link"
            href="javascript:void(0);"
            @click="setUiLanguage('tw')"
          >
            <span class="nav-link-inner--text">Chinese</span>
          </a>
        </li>
      </ul>
      <!-- <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
        <li>
          <a
            class="nav-link"
            target="_blank"
            href="https://www-old.budaedu.org/en/"
          >
            <span class="nav-link-inner--text">English</span>
          </a>
        </li>
      </ul> -->
      <!-- <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
        <base-dropdown tag="li" class="nav-item">
          <a slot="title" href="javascript:void(0);" class="nav-link" data-toggle="dropdown" role="button">
            <span class="nav-link-inner--text">{{ $t('lang') }}</span>
            <i class="ni ni-bold-right d-lg-none"></i>
          </a>
          <a
            class="dropdown-item dropdown-item-lg"
            @click="setUiLanguage('tw')"
          >中文</a>
          <a
            class="dropdown-item dropdown-item-lg"
            @click="setUiLanguage('en')"
          >English</a>
        </base-dropdown>
      </ul> -->
    </base-nav>
    <dharma-application-form ref="application_form"></dharma-application-form>
  </header>
</template>
<script>
import Vue from 'vue'
import Router from 'vue-router'
import VueLocalStorage from 'vue-localstorage'
import { IconsPlugin } from 'bootstrap-vue'

import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

import DharmaApplicationForm from '@/components/forms/dharma-application-form/DharmaApplicationForm'

import i18n from '@/plugins/i18n.js'

Vue.use(IconsPlugin)
Vue.use(Router)
Vue.use(VueLocalStorage)

export default {
  i18n,
  props: {
    show_application_list_entry: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    base_path() {
      return process.env.VUE_APP_BASE_PATH || '/'
    }
  },
  methods: {
    setUiLanguage(language) {
      this.$i18n.locale = language
      this.$localStorage.set('ui-lang', language)
      this.$router.push({ name: 'index' })
    },
    showApplicationList() {
      this.$bvModal.show(`application-list-${this.$refs[`application_form`].uuid}`)
    }
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  mounted() {
  },
  components: {
    BaseDropdown,
    BaseNav,
    CloseButton,
    DharmaApplicationForm
  }
};
</script>

<style scoped>
@media (max-width: 767px) {
  .word-logo {
    width: 27.4vh;
  }
}

.header-action-container {
  position: absolute;
  top: 90px;
  right: 15px;
  z-index: 10;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.header-circle-decoration {
  width: 40px;
  height: 40px;
  background-color: rgba(0, 0, 0, 1.0);
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 4px;
}

.action-text {
  font-size: 12px;
  color: #333;
  font-weight: bold;
}
</style>
